import React from "react";
import { IInterview } from "../../types";

interface InterviewDetailsModalProps {
  interview: IInterview;
  onClose: () => void;
}

const InterviewDetailsModal = ({
  interview,
  onClose,
}: InterviewDetailsModalProps) => {
  const employer = interview.employer;
  const user = interview.application.user;

  return (
    <div className="fixed inset-0 p-2 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 w-full max-w-2xl">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-semibold">Interview Details</h2>
          <button
            onClick={onClose}
            className="text-gray-500 hover:text-gray-700"
          >
            &times;
          </button>
        </div>

        <div className="space-y-4">
          <div className="flex items-center justify-between space-x-4">
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Candidate</h3>
              <p>
                {user.firstName} {user.lastName}
              </p>
            </div>
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Email</h3>
              <p>{user?.email}</p>
            </div>
          </div>

          <div className="flex items-center justify-between space-x-4">
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Employer</h3>
              <p>{employer?.companyName}</p>
            </div>
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Job Title</h3>
              <p>{interview.subject}</p>
            </div>
          </div>

          <div className="flex items-center justify-between space-x-4">
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Subject</h3>
              <p>{interview.subject}</p>
            </div>
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Status</h3>
              <p
                className={`capitalize ${
                  interview.status === "accepted"
                    ? "text-emerald-500"
                    : interview.status === "pending"
                    ? "text-amber-500"
                    : "text-rose-500"
                }`}
              >
                {interview.status}
              </p>
            </div>
          </div>

          <div>
            <h3 className="font-medium text-gray-500 text-sm">
              Interview Link
            </h3>
            <a
              href={interview.link}
              target="_blank"
              rel="noopener noreferrer"
              className="text-blue-500 hover:underline"
            >
              {interview.link}
            </a>
          </div>

          <div>
            <h3 className="font-medium text-gray-500 text-sm">Message</h3>
            <div
              dangerouslySetInnerHTML={{ __html: interview.message }}
              className="prose"
            />
          </div>

          <div className="flex items-center justify-between space-x-4">
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Created At</h3>
              <p>{new Date(interview.createdAt).toLocaleDateString()}</p>
            </div>
            <div className="flex-1">
              <h3 className="font-medium text-gray-500 text-sm">Updated At</h3>
              <p>{new Date(interview.updatedAt).toLocaleDateString()}</p>
            </div>
          </div>
        </div>

        <div className="mt-6 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 border border-rose-500 text-rose-500 rounded-md"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default InterviewDetailsModal;
